import { render, staticRenderFns } from "./OrdersList.vue?vue&type=template&id=48e3b170&scoped=true&"
import script from "./OrdersList.vue?vue&type=script&lang=js&"
export * from "./OrdersList.vue?vue&type=script&lang=js&"
import style0 from "./OrdersList.vue?vue&type=style&index=0&id=48e3b170&lang=scss&scoped=true&"
import style1 from "./OrdersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e3b170",
  null
  
)

export default component.exports